const weak = new WeakMap()
export default {
  bind (el, binding) {
    const handleFun = (e) => { // 判断所点击dom是否为el的节点
      if (!el.contains(e.target)) {
        binding.value(e)
      }
    }
    if (!weak.get(el)) {
      weak.set(el, handleFun)
      document.addEventListener('click', handleFun)
    }
  },
  unbind (el) {
    document.removeEventListener('click', weak.get(el))
  }
}
